/*
 * @Author: mayanxia 
 * @Date: 2022-01-11 11:25:53 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-06-13 10:55:28
 */

<template>
    
    <a-modal
      :title="title"
      :width="800"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :okButtonProps="{ props: {disabled: disableSubmit} }"
      :maskClosable="maskClosable"
      @ok="handleOk"
      @cancel="handleCancel"
      :cancelText="$t('关闭')">
        <a-spin :spinning="confirmLoading">
        <a-form-model ref="formModal" :model="model" :rules="rules" :colon="false" layout="vertical">
            <a-row :gutter="48">
              <a-col :span="12">
                    <a-form-model-item :label="$t('规则名称')"  prop="warnName">
                    <a-input :disabled="disableSubmit||isUsed" v-model="model.warnName" :placeholder="$t('请输入规则名称')"  ></a-input>
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item :label="$t('告警类型')"  prop="warnType">
                        <a-select :disabled="disableSubmit||isUsed" v-model="model.warnType" :placeholder="$t('请选择告警类型')">
                            <a-select-option v-for="data in warnTypeListOptions" :key="data.key" :value="data.key">
                              {{data.title}}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                </a-col>
                <template v-if="model.warnType == 1">
                  <a-col :span="12">
                    <a-form-model-item :label="$t('规则类型')" prop="compareType">
                        <j-dict-select-tag v-model="model.compareType" :placeholder="$t('请选择规则类型')" dictCode="maintenance_compare_type" :disabled="disableSubmit||isUsed" />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="12" style="display: flex;align-items: center">
                    <a-form-model-item :label="$t('比较值')" prop="compareValue1">
                        <a-input-number :disabled="disableSubmit||isUsed" style="width: 50%；display: inline-block;" v-model="model.compareValue1" :placeholder="$t('请输入比较值')" :precision="1" :min="0"></a-input-number>
                    </a-form-model-item>
                    <template v-if="model.compareType == 'between'">
                    -
                    <a-form-model-item :label="$t('比较值')" prop="compareValue2">
                        <a-input-number :disabled="disableSubmit||isUsed" style="width: 50%；display: inline-block;" v-model="model.compareValue2" :placeholder="$t('请输入比较值')" :precision="1" :min="0"></a-input-number>
                    </a-form-model-item>
                    </template>
                    <span class="unit">V</span>
                  </a-col>
                  <a-col :span="12">
                      <a-form-model-item :label="$t('告警等级')" prop="warnClevel">
                          <j-dict-select-tag v-model="model.warnClevel" :placeholder="$t('请选择告警等级')" dictCode="maintenance_warn_clevel" :disabled="disableSubmit||isUsed" />
                      </a-form-model-item>
                  </a-col>
                  <a-col :span="12">
                      <a-form-model-item :label="$t('次数阈值(输入0代表不限制)')" prop="warnTimes">
                          <a-input-number :disabled="disableSubmit||isUsed" style="width: 100%" v-model="model.warnTimes" :placeholder="$t('请输入次数阈值')" :precision="0" :min="0"></a-input-number>
                      </a-form-model-item>
                  </a-col>
                </template>
                <template v-if="model.warnType == 3||model.warnType == 6">
                  <a-col :span="12">
                      <a-form-model-item :label="$t('失联告警天数')" prop="compareValue1">
                          <a-input-number :disabled="disableSubmit||isUsed" style="width: 100%" v-model="model.compareValue1" :placeholder="$t('请输入告警天数')" :precision="0" :min="1"></a-input-number>
                      </a-form-model-item>
                  </a-col>
                </template>
                <template v-if="model.warnType == 5">
                  <a-col :span="12">
                      <a-form-model-item :label="$t('关阀走水量')" prop="compareValue1">
                          <a-input-number :disabled="disableSubmit||isUsed" style="width: 100%" v-model="model.compareValue1" :placeholder="$t('请输入关阀走水量')" :precision="2" :min="0"></a-input-number>
                      </a-form-model-item>
                  </a-col>
                </template>
                <a-col :span="12">
                    <a-form-model-item :label="$t('是否启用')" prop="warnState">
                        <a-switch :disabled="disableSubmit" v-model="model.warnState" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="24">
                    <a-form-model-item :label="$t('备注')"  prop="remark">
                        <a-textarea :disabled="disableSubmit" v-model="model.remark" rows="3" :placeholder="$t('请输入备注')" style="width:100%"/>
                    </a-form-model-item>
                </a-col>
            </a-row>
        </a-form-model>
      </a-spin>
    </a-modal>
</template>
<script>
import i18n from '@/i18n'

  import { httpAction, getAction } from '@/api/manage'
  import { listSize } from '@/utils/util'

  const warnTypeList = [
    {key: 1,title: i18n.t('电池电压告警')},
    {key: 2,title: i18n.t('信号告警')},
    {key: 3,title: i18n.t('已开户失联告警')},
    {key: 4,title: i18n.t('复位告警')},
    {key: 5,title: i18n.t('关阀走水')},
    {key: 6,title: i18n.t('未开户失联告警')}
  ]

  export default {
    name: 'MeterUseWarnConfigModal',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
          warnName:undefined,
          warnType: 1,
          compareType: undefined,
          compareValue1: undefined,
          compareValue2: undefined,
          warnState: false,
          warnClevel:undefined,
          warnTimes: undefined,
        },
        maskClosable:false,
        title:this.$t("操作"),
        visible: false,
        disableSubmit:false,
        confirmLoading: false,
        url: {
          add: "/jeecg-charge/meter/meterMaintenanceWarnConfig/add",
          edit: "/jeecg-charge/meter/meterMaintenanceWarnConfig/edit",
          queryById: "/jeecg-charge/meter/meterMaintenanceWarnConfig/queryById"
        },
        isUsed: false
      }
    },
    computed: {
      // i18n：告警类型下拉选项（title 随语言切换）
      warnTypeListOptions() {
        return warnTypeList.map(item => ({ ...item, title: this.$t(item.title) }))
      },
      // i18n：校验消息使用 computed 以响应语言切换
      rules() {
        return {
          warnName:[{ required: true, message: this.$t('请输入规则名称')}],
          warnType:[{ required: true, message: this.$t('请选择告警类型')}],
          compareType:[{ required: true, message: this.$t('请选择规则类型')}],
          compareValue1: [{
                // type: "number",
                required: true,
                message: this.$t('输入有误')
              },
              {
                validator: this.compareToNextValue,
              }
          ],
          compareValue2: [{
                // type: "number",
                required: true,
                message: this.$t('输入有误')
              },
              {
                validator: this.compareToFirstValue,
              }
          ],
          warnClevel: [{ required: true, message: this.$t('请选择告警等级')}],
          warnTimes: [{ required: true, message: this.$t('请输入次数阈值')}]
        }
      }
    },
    created () {
    },
    methods: {
        
      add () {
          console.log("添加")
        this.edit(this.model);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        console.log(this.model)
        if(this.model.warnState === 1) {
          this.model.warnState = true
        }else{
          this.model.warnState = false
        }
        this.visible = true;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.formModal.validate(valid => {
          if(valid) {
            that.confirmLoading = true;
            let params = {...this.model}
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            if(this.model.warnState) {
              params.warnState = 1
            }else{
              params.warnState = 0
            }
            httpAction(httpurl,params,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
                this.close()
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
        })
      },
      close () {
        this.$emit('close');
        this.model = this.$options.data.call(this).model;
        this.$refs.formModal.resetFields()
        console.log(this.model)
        this.disableSubmit = false;
        this.isUsed = false;
        this.visible = false;
      },

      handleCancel () {
        this.close();
      },
      compareToFirstValue(rule, value, callback) {
        const down = this.model.compareValue1;
        if(this.model.compareType != 'between'){
          callback();
        }else if (value !== "" && down !== "" && value <= down) {
          callback(this.$t('电池电压输入有误'));
        } else {
          callback()
        }
      },
      compareToNextValue(rule, value, callback) {
        const up = this.model.compareValue2;
        if(this.model.compareType != 'between'){
          callback();
        }else if (value !== "" && up !== ""&& value >= up) {
          callback(this.$t('电池电压输入有误'));
        }else{
          callback()
        }
      },
    }
  }
</script>